import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FileCopy as CopyIcon, Check as CopiedIcon } from '@mui/icons-material';
import Button from './editors/mui/Button';
import { IconButton } from 'new/elements/IconButton/IconButton';

const styles = {
  buttonText: {
    fontSize: 12,
  },
  copyButtonStyleDefault: {
    width: '100%',
    lineHeight: '38px',
    height: 'auto',
    margin: 0,
    border: 4,
    opacity: 1,
    minWidth: 'unset',
  },
  copyButtonStyleCopied: {
    width: '100%',
    lineHeight: '38px',
    height: 'auto',
    margin: 0,
    border: 4,
    opacity: 0.8,
    minWidth: 'unset',
  },
};

class CopyText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      justCopied: 0,
    };

    this._handleCopy = this._handleCopy.bind(this);
  }

  render() {
    const { displayText, baseText, iconButtonSx, iconSize } = this.props;
    const { justCopied } = this.state;

    return (
      <div
        style={{
          display: 'flex',
        }}
      >
        <pre
          style={{
            marginRight: 12,
            whiteSpace: 'pre-line',
            wordBreak: 'break-all',
          }}
          className="url-snippet"
        >
          {displayText}
        </pre>
        <div className="copy-url" style={{ justifySelf: 'flex-end' }}>
          <CopyToClipboard text={baseText} onCopy={this._handleCopy}>
            <IconButton
              color="primary"
              sx={{
                color: 'var(--color-primary-500)',
                ...(iconButtonSx || {}),
              }}
            >
              {justCopied ? (
                <CopiedIcon fontSize={iconSize || 'medium'} />
              ) : (
                <CopyIcon fontSize={iconSize || 'medium'} />
              )}
            </IconButton>
          </CopyToClipboard>
        </div>
      </div>
    );
  }

  _handleCopy() {
    this.setState({ justCopied: true });

    setTimeout(() => {
      this.setState({ justCopied: false });
    }, 2000);
  }
}

export default CopyText;
